import type { AdlinksContainerProps } from '@vakantiesnl/components/src/molecules/AdlinksContainer';
import { getClientIdFromGACookie } from '@vakantiesnl/services/src/util/googleClientId';
import { type Adlinks as AdlinkTypes, type MicroCopy } from '@vakantiesnl/types';

export const adlinksFormatter = (
	adlinks: AdlinksContainerProps['adlinks'],
	asPath: string,
	microCopies: MicroCopy,
	onAdlinkClick: AdlinksContainerProps['onAdlinkClick'],
	/** Content of the Google Analytics cookie */
	googleAnalyticsCookie?: string,
): AdlinkTypes.FormattedAdlink[] => {
	// Replace ? with / in the decoded URI path
	const dpParam = asPath ? `&dp=${decodeURIComponent(asPath).replace('?', '/')}` : '';
	const cidValue = googleAnalyticsCookie ? googleAnalyticsCookie : getClientIdFromGACookie();
	const cidParam = cidValue ? `&cid=${cidValue}` : '';

	return adlinks?.map((adlink, index) => {
		return {
			index,
			to: `/zvr-visit?q=${adlink.trackingUrl}${dpParam}${cidParam}&pageType=accommodation`,
			buttonText: microCopies['common.view'],
			exposureCode: adlink.exposureCode,
			text: adlink.title,
			logo: adlink.logoUrl,
			onClick: onAdlinkClick
				? (): void =>
						onAdlinkClick({
							ad_link_feed_id: adlink.supplierId,
							ad_link_name: adlink.title,
							ad_link_position: index,
							ad_link_total: adlinks.length,
						})
				: undefined,
		};
	});
};
